import React from 'react'
import Layout from '../../components/auth/layout'
import LoginForm from '../../components/auth/login'
import { v1_login } from '../../actions/v1/auth'
import { v1_modules } from '../../actions/v1/module';
import { setSessionStorage } from '../../utils'
import constant from '../../constant'
import swal from 'sweetalert';

const getPostLoginRedirectUrl = (location = {}) => {
    const fallbackUrl = constant.Authedcomponent.dashboard.url;
    const blockedPaths = new Set([
        constant.nonAuthedcomponent.login.url,
        constant.nonAuthedcomponent.forgotPassword.url,
        constant.nonAuthedcomponent.resetPassword.url,
        constant.nonAuthedcomponent.lockScreen.url,
        constant.Authedcomponent.logout.url
    ]);

    const fromState = location?.state?.from;
    const stateTarget = fromState?.pathname
        ? `${fromState.pathname}${fromState.search || ''}${fromState.hash || ''}`
        : '';

    const query = new URLSearchParams(location?.search || '');
    const queryTarget = (query.get('redirect') || '').trim();

    const target = stateTarget || queryTarget;
    if (!target) {
        return fallbackUrl;
    }

    if (!target.startsWith('/') || target.startsWith('//')) {
        return fallbackUrl;
    }

    const targetPath = target.split('?')[0].split('#')[0];
    if (blockedPaths.has(targetPath)) {
        return fallbackUrl;
    }

    return target;
};

const Login = (props) => {
    const onLogin = (model) => {
        v1_login(model).then(res => {
            if (res.status) {
                // setStorage(constant.keys.userDetails, res.result.ud);
                // setStorage(constant.keys.userToken, res.result.token);
                setSessionStorage(constant.keys.userDetails, res.result.ud);
                setSessionStorage(constant.keys.userToken, res.result.token);
                v1_modules()
                    .then((modulesRes) => {
                        if (modulesRes?.status && modulesRes?.result) {
                            setSessionStorage(constant.keys.userModule, modulesRes.result);
                        }
                    })
                    .catch(() => {
                        // Modules can still be fetched later by sidebar; avoid blocking login.
                    })
                    .finally(() => {
                        props.history.replace(getPostLoginRedirectUrl(props.location));
                    });
            }
            else {
                swal({
                    title: res.error,
                    icon: "warning",
                    dangerMode: true,
                })
            }
        })
    }
    return (
        <React.Fragment>
            <Layout>
                <LoginForm
                    onSubmit={onLogin}
                />
            </Layout>
        </React.Fragment>)
}

export default Login
